import { FC, useEffect, useRef } from 'react'
import { useLayout } from '../../../_metronic/layout/core'
import { useHistory, useParams } from 'react-router-dom'
import { KTSVG } from '../../../_metronic/helpers'

const ExperienceBookingSuccessPage: FC = () => {
    const { config, setLayout } = useLayout()
    const restoreRef = useRef(config)
    const history = useHistory()
    const { id } = useParams<{ id: string }>()

    useEffect(() => {
        restoreRef.current = config
        setLayout({
            ...config,
            header: { ...config.header, display: false },
            toolbar: { ...config.toolbar, display: false },
            aside: { ...config.aside, display: false },
            footer: { ...config.footer, display: true },
            main: {
                ...config.main,
                body: { ...config.main?.body, class: 'app-blank' },
            },
        })
        document.body.classList.add('bg-experience-preview');
        document.getElementById('kt_footer')?.classList.add('bg-experience-preview');
    }, [])

    return (<>
        <div className="booking-success-page tap-flex-center">
            <div className='tap-flex-center flex-column gap-12'>
                <header className="request-page__header">
                    <h1>Your Booking is Confirmed!</h1>
                </header>
                <p className='request-summary__note'>
                    Your booking has been successfully confirmed. You are now registered for this experience. We look forward to welcoming you and creating a memorable moment within the Nobilis community.
                </p>
                <div onClick={()=>history.go(-2)} className="tap-add-experience-2-btn-secondary tap-flex-center">
                    Go back &nbsp;<KTSVG path='/media/svg/nobilis/vector1.svg' />
                </div>
            </div>
        </div>
    </>);
}
export { ExperienceBookingSuccessPage }